/// <amd-module name="TFS/Admin/Views/OrganizationOverview/Components/SoftDeletedProjects/RestoreDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { IVssPageContext } from "VSS/Platform/Context";
import { FormItem } from "VSSUI/FormItem";
import { TextField } from "VSSUI/TextField";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { ObservableValue } from "VSS/Core/Observable";
import { validateProjectName } from "TFS/Admin/Common/Util/NameValidator";
import { format } from "VSS/Core/Util/String";
import { ContentSize } from "VSSUI/Callout";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";

import AdminResources = require("TFS/Admin/Views/OrganizationOverview/Resources");

export interface IRestoreProjectDialogProps {
    pageContext: IVssPageContext;
    projectId: string;
    projectName: string;
    secondProjectName?: string;
    onCancel: () => void;
    onRestoreProject: (projectId: string, projectName: string) => void;
}

interface IRestoreProjectDialogState {
    isValid: boolean;
}

export class RestoreProjectDialog extends React.Component<IRestoreProjectDialogProps, IRestoreProjectDialogState> {
    private projectName = new ObservableValue<string>("");
    private errorMessage = new ObservableValue<string>("");
    private displayName: string;

    constructor(props: IRestoreProjectDialogProps) {
        super(props);
        this.state = {
            isValid: false
        };
    }

    public render(): JSX.Element {
        this.displayName = this.props.secondProjectName ? this.props.secondProjectName : this.props.projectName;
        return (
            <Dialog
                onDismiss={() => {
                    this.props.onCancel();
                }}
                contentSize={ContentSize.Large}
                className="restore-project-dialog"
                titleProps={{
                    text: AdminResources.RestoreDialogTitle,
                    className: "fontWeightSemiBold"
                }}
                footerButtonProps={[
                    {
                        text: AdminResources.Cancel,
                        onClick: () => {
                            this.props.onCancel();
                        }
                    },
                    {
                        disabled: !this.state.isValid,
                        text: AdminResources.RestoreDialogConfirm,
                        onClick: () => this.props.onRestoreProject(this.props.projectId, this.projectName.value),
                        className: "restore-project-button",
                        primary: true
                    }
                ]}
            >
                <div className="flex-column restore-project-dialog-content">
                    <div>
                        <div className="restore-project-first-paragraph">
                            <FormatComponent format={AdminResources.RestoreDialogParagraph1}>
                                <span className="restore-project-name fontWeightSemiBold">{this.displayName}</span>
                            </FormatComponent>
                        </div>
                        {this.props.secondProjectName ? (
                            <div>
                                <div className="restore-project-second-paragraph top-margin">
                                    <FormatComponent format={AdminResources.RestoreDialogParagraph2}>
                                        <span className="restore-project-name fontWeightSemiBold">{this.props.projectName}</span>
                                    </FormatComponent>
                                </div>
                            </div>
                        ) : (
                            <div className="restore-project-second-paragraph top-margin" />
                        )}
                        <FormItem
                            className="restore-button-text-field top-margin"
                            message={this.errorMessage.value}
                            error={this.errorMessage.value !== ""}
                        >
                            <TextField
                                value={this.projectName}
                                onChange={this._onNameChanged}
                                placeholder={AdminResources.RestoreDialogPlaceholder}
                                ariaLabel={AdminResources.RestoreDialogPlaceholder}
                            />
                        </FormItem>
                    </div>
                </div>
            </Dialog>
        );
    }

    private _onNameChanged = (event: any, value: string) => {
        this.projectName.value = value;
        if (!value) {
            this.errorMessage.value = "";
            this.setState({ isValid: false });
        } else if (
            localeIgnoreCaseComparer(value, this.props.projectName) === 0 ||
            (this.props.secondProjectName && localeIgnoreCaseComparer(value, this.props.secondProjectName) === 0)
        ) {
            this.errorMessage.value = AdminResources.RestoreDialogSameName;
            this.setState({ isValid: false });
        } else if (!validateProjectName(value)) {
            this.errorMessage.value = format(AdminResources.InvalidProjectNameError, this.projectName.value);
            this.setState({ isValid: false });
        } else {
            this.errorMessage.value = "";
            this.setState({ isValid: true });
        }
    };
}
